import { stringify } from 'qs';
import * as R from 'ramda';

export const TOTAL_COUNT_HEADER = 'x-atom-total';
export const ATOM_USER_HEADER = 'x-atom-user';
export const ATOM_DEVICE_HEADER = 'x-atom-device';
export const ATOM_CLIENT_TIMEZONE_HEADER = 'x-atom-client-timezone';
export const ATOM_IMPERSONATE_USER_HEADER = 'x-atom-impersonate-user';
export const ATOM_LLM_MODEL_HEADER = 'x-atom-llm-model';
export const ATOM_LLM_OVERRIDES_HEADER = 'x-atom-llm-overrides';

export const DEFAULT_HEADERS = {
  accept: 'application/json',
  [ATOM_DEVICE_HEADER]: 'desktop',
  [ATOM_CLIENT_TIMEZONE_HEADER]:
    Intl.DateTimeFormat().resolvedOptions().timeZone,
};

export const DEFAULT_OPTIONS = {
  headers: DEFAULT_HEADERS,
};

export const buildEndpointWithParamsFromData = (baseEndpoint, data) => {
  if (R.isEmpty(data)) {
    return baseEndpoint;
  }

  const qsString = stringify(data, {
    encode: false,
    arrayFormat: 'repeat',
    sort: (item, next) => item?.localeCompare(next),
    strictNullHandling: true,
  });

  return `${baseEndpoint}?${qsString}`;
};
